module.exports = __webpack_public_path__ + "static/chemistry-f2e7bc61d48d0aa329c571a8015ffab8.svg";